import { Component } from "react";
import { Image, Grid, List } from 'semantic-ui-react';
import logo from '../../assets/logo.png';
import logoHdf from '../../assets/logoHdf.png';
// import './SubsidyContract.css';

class SubsidyContract extends Component {
    getLpAddress = () => {
        let lp = this.props.projectState.leadPartner;
        let lpAddress = lp.addresses.filter(a => a.type === 'Organization')[0];
        return lpAddress?.houseNumber + ' ' + lpAddress?.street + ' ' + lpAddress?.postalCode + ' ' + lpAddress?.city + ' ' + lpAddress?.country;
    }

    getTitleEn = () => {
        let title = this.props.projectState.project.title;
        let titleEn = title.filter(t => t.language === 'EN')[0];

        return titleEn?.translation;
    }

    getTitle = () => {
        let title = this.props.projectState.project.title;
        let titleOrig = title.filter(t => t.language !== 'EN')[0];
        if (titleOrig) {
            return titleOrig?.translation;
        } else {
            return this.getTitleEn();
        }
    }

    getCommissionDate = () => {
        let ind = this.props.projectState.project.callSettings.callId - 1;
        return this.props.projectState.commissionDates[ind];
    }

    renderPartnerFR = () => {
        return (
            <Grid.Column width={8}>
                <h3>{this.props.projectState.leadPartner.nameInOriginalLanguage}</h3>
            </Grid.Column>
        )
    }

    renderPartnerEN = () => {
        return (
            <Grid.Column width={8}>
                <h3>{this.props.projectState.leadPartner.nameInEnglish}</h3>
            </Grid.Column>
        )
    }

    renderPartnerDetail = () => {
        return (
            <Grid.Row>
                <Grid.Column width={8}>
                    <p>{this.getLpAddress()}</p>
                    <p>- ci-après dénommé « chef de file », pour {this.props.projectState.project.customIdentifier} - {this.props.projectState.project.acronym} - {this.getTitleEn()} est conclu sur la base des dispositions légales indiquées à l'article 1.1.</p>
                </Grid.Column>
                <Grid.Column width={8}>
                    <p>{this.getLpAddress()}</p>
                    <p>- hereinafter referred to as Lead Partner (LP), for {this.props.projectState.project.customIdentifier} - {this.props.projectState.project.acronym} - {this.getTitleEn()} is concluded on the basis of the legal provisions indicated in article 1.1.</p>
                </Grid.Column>
            </Grid.Row>

        )
    }


    renderSubsidyHeader = () => {
        return (
            <Grid>
                <Grid.Row className="espace-haut">
                    <Grid.Column width={8}>
                        <h2>Contrat de subvention</h2>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <h2>Subsidy Contract</h2>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        pour la mise en œuvre du projet
                    </Grid.Column>
                    <Grid.Column width={8}>
                        for the implementation of the project
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={16}>
                        <h3 className="center-text">{this.props.projectState.project.customIdentifier} {this.props.projectState.project.acronym}</h3>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        Préambule
                    </Grid.Column>
                    <Grid.Column width={8}>
                        Preamble
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        Le contrat suivant entre
                    </Grid.Column>
                    <Grid.Column width={8}>
                        The following contract between
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <h3>La Région Hauts-de-France,</h3>
                        <p>Hôtel de Région, 151, avenue du Président Hoover, 59555 LILLE Cedex, France</p>
                        <p>- agissant en tant qu'autorité de gestion (AG) du programme Interreg Europe du Nord-Ouest</p>
                       
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <h3>Région Hauts-de-France,</h3>
                        <p>Hôtel de Région, 151, avenue du Président Hoover, 59555 LILLE Cedex, France</p>
                        <p>- acting as Managing Authority (MA) of the programme Interreg North-West Europe</p>
                        
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                    <p>et</p>
                    </Grid.Column>
                    <Grid.Column width={8}>
                    <p>and</p>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        {this.renderPartnerFR()}
                    </Grid.Column>
                    <Grid.Column width={8}>
                        {this.renderPartnerEN()}
                    </Grid.Column>
                </Grid.Row>

                {this.renderPartnerDetail()}

                <Grid.Row className='page-break-before'>
                    <Grid.Column width={8}>
                        <h3>
                            Liste des abréviations :
                        </h3>
                        <p>
                            Programme -Programme Interreg Europe du Nord-Ouest<br />
                            AA - Autorité d'audit<br />
                            CE - Commission européenne<br />
                            FEDER – Fonds européen de développement régional<br />
                            UE – Union européenne<br />
                            Jems - Système commun de suivi électronique<br />
                            SC - Secrétariat conjoint<br />
                            CF - Chef de file<br />
                            AG - Autorité de gestion<br />
                            PP - Partenaire de projet (PPs - Partenaires de projet)
                        </p>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <h3>
                            List of abbreviations:
                        </h3>
                        <p>
                            Programme – Interreg North-West Europe Programme<br />
                            AA –Audit Authority<br />
                            EC - European Commission<br />
                            ERDF – European Regional Development Fund<br />
                            EU – European Union<br />
                            Jems – Joint Electronic Monitoring System<br />
                            JS - Joint Secretariat<br />
                            LP - Lead Partner<br />
                            MA - Managing Authority<br />
                            PP - Project Partner (PPs – Project Partners)
                        </p>
                    </Grid.Column>
                </Grid.Row>

            </Grid>
        )
    };

    renderArticle1 = () => {
        return (
            <Grid>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <h3>Article 1 : Cadre juridique et base contractuelle</h3>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <h3>Article 1: Legal framework and contractual basis</h3>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        1. Les dispositions légales et les documents suivants constituent la base contractuelle du présent contrat de subvention et le cadre juridique de la mise en œuvre du projet {this.props.projectState.project.acronym} - {this.getTitle()} :<br />
                        <List as='ul'>
                            <List.Item as='li'>Les règlements, les actes délégués et les actes d'exécution des Fonds structurels et d'investissement européens pour la période 2021-2027, comme précisé ci-dessous ;</List.Item>
                            <List.Item as='li'>Le Programme Interreg Europe du Nord-Ouest, approuvé par la Commission européenne le 24 août 2022 (décision n° 2021TC16RFTN005), établissant le programme (ci-après dénommé programme Interreg Europe du Nord-Ouest) ;</List.Item>
                            <List.Item as='li'>Le droit français applicable à cette relation contractuelle ;</List.Item>
                        </List>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        1. The following legal provisions and documents constitute the contractual basis of this subsidy contract and the legal framework for the implementation of the project {this.props.projectState.project.acronym} - {this.getTitle()}:<br />
                        <List as='ul'>
                            <List.Item as='li'>The European Structural and Investment Funds Regulations, Delegated and Implementing Acts for the 2021-2027 period, as further specified below;</List.Item>
                            <List.Item as='li'>The Interreg North-West Europe Programme, approved by the European Commission on 24 August 2022 (Decision No. 2021TC16RFTN005) setting the programme (hereinafter referred to as Interreg North-West Europe programme);</List.Item>
                            <List.Item as='li'>The laws of France applicable to this contractual relationship;</List.Item>
                        </List>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        2. Les lois et documents suivants constituent le cadre juridique applicable aux droits et obligations des parties au présent contrat :<br />
                        <List as='ul'>
                            <List.Item as='li'>Le règlement (UE, Euratom) n° 2018/1046 du Parlement européen et du Conseil du 18 juillet 2018 relatif aux règles financières applicables au budget général de l'Union et toute modification, ainsi que les actes délégués ou d'exécution y afférents ;</List.Item>
                            <List.Item as='li'>Les règlements, actes délégués et actes d'exécution des Fonds structurels et d'investissement européens pour la période 2021-2027, notamment :
                                <List>
                                    <List.Item className="sub-list">Le règlement (UE) 2021/1060 du Parlement européen et du Conseil du 24 juin 2021 portant dispositions communes relatives au Fonds européen de développement régional, au Fonds social européen plus, au Fonds de cohésion, au Fonds pour une transition juste et au Fonds européen pour les affaires maritimes, la pêche et l'aquaculture, et établissant les règles financières applicables à ces Fonds et au Fonds « Asile, migration et intégration », au Fonds pour la sécurité intérieure et à l'instrument de soutien financier de soutien à la gestion des frontières et à la politique des visas, et abrogeant le Règlement (CE) n° 1303/2013 du Conseil, ainsi que tout amendement ;</List.Item>
                                    <List.Item className="sub-list">Le règlement (UE) 2021/1058 du Parlement européen et du Conseil du 24 juin 2021 relatif au Fonds européen de développement régional et au Fonds de cohésion, et abrogeant le règlement (CE) n° 1301/2013 du Conseil, ainsi que tout amendement ;</List.Item>
                                    <List.Item className="sub-list">Le règlement (UE) 2021/1059 du Parlement européen et du Conseil du 24 juin 2021 portant dispositions relatives à l'objectif « coopération territoriale européenne » (Interreg) soutenu par le Fonds européen de développement régional et les instruments de financement extérieur, et abrogeant le règlement (CE) n° 1299/2013 du Conseil, ainsi que tout amendement ;</List.Item>
                                </List>
                            </List.Item>
                        </List>
                        <List as='ul'>
                            <List.Item as='li'>Le règlement (UE) 2016/679 du 27 avril 2016 relatif à la protection des personnes physiques à l'égard du traitement des données à caractère personnel et à la libre circulation de ces données, et abrogeant la directive 95/46/CE (Règlement général sur la protection des données, RGPD) ;</List.Item>
                            <List.Item as='li'>Les articles 107 et 108 du Traité sur le fonctionnement de l'Union européenne, le règlement (UE) n° 1407/2013 de la Commission relatif à l'application des articles 107 et 108 du Traité sur le fonctionnement de l'Union européenne aux aides de minimis, le règlement (UE) 2021/1237 du 23 juillet 2021 modifiant le règlement (UE) n° 651/2014 déclarant certaines catégories d'aides compatibles avec le marché intérieur en application des articles 107 et 108 du traité ; les actes délégués et d'exécution, ainsi que toutes les décisions et jugements applicables en matière d'aides d'État ;</List.Item>
                            <List.Item as='li'>Toute autre législation de l'UE et les principes sous-jacents applicables au CF et aux PPs, y compris la législation établissant des dispositions sur la concurrence et l'entrée sur les marchés, la protection de l'environnement, et les principes de développement durable, d'égalité des chances, de non-discrimination et d'égalité entre les hommes et les femmes ;</List.Item>
                            <List.Item as='li'>Règles nationales applicables au CF et à ses PPs et à leurs activités ;</List.Item>
                            <List.Item as='li'>Les données du projet, comprenant toute la documentation récente du projet, comme le formulaire de candidature et toutes les informations du projet disponibles dans le système électronique (Jems) ;</List.Item>
                            <List.Item as='li'>Tous les manuels, directives et tout autre document pertinent pour la mise en œuvre du projet (par exemple, le manuel du programme) dans leur dernière version, telle que publiée sur le site Internet du Programme.</List.Item>
                        </List>
                        En cas de modification des documents susmentionnés, ainsi que de tout autre document ou donnée pertinent pour la relation contractuelle, la dernière version est applicable.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        2. The following laws and documents constitute the legal framework applicable to the rights and obligations of the parties to this contract:<br />
                        <List as='ul'>
                            <List.Item as='li'>Regulation (EU, Euratom) No 2018/1046 of the European Parliament and of the Council of 18 July 2018 on the financial rules applicable to the general budget of the Union and any amendment, together with related Delegated or Implementing Acts;</List.Item>
                            <List.Item as='li'>The European Structural and Investment Funds Regulations, Delegated and Implementing Acts for the 2021-2027 period, especially:
                                <List>
                                    <List.Item className="sub-list">Regulation (EU) No 2021/1060 of the European Parliament and of the Council of 24 June 2021, laying down common provisions on the European Regional Development Fund, the European Social Fund Plus, the Cohesion Fund, the Just Transition Fund, and the European Maritime, Fisheries and Aquaculture Fund and financial rules for those and for the Asylum, Migration and Integration Fund, the Internal Security Fund and the Instrument for Financial Support for Border Management and Visa Policy, and repealing Council Regulation (EC) No 1303/2013, and any amendment;</List.Item>
                                    <List.Item className="sub-list">Regulation (EU) No 2021/1058 of the European Parliament and of the Council of 24 June 2021 on the European Regional Development Fund and on the Cohesion Fund, and repealing Regulation (EC) No 1301/2013, and any amendment;</List.Item>
                                    <List.Item className="sub-list">Regulation (EU) No 2021/1059 of the European Parliament and of the Council of 24 June 2021 on specific provisions for the European territorial goal (Interreg) supported by the European Regional Development Fund and external financing instruments, and repealing Regulation (EC) No 1299/2013, and any amendment;</List.Item>
                                </List>
                            </List.Item>
                        </List>
                        <List as='ul'>
                            <List.Item as='li'>Regulation (EU) 2016/679 of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing directive 95/46/EC (General Data Protection Regulation, GDPR);</List.Item>
                            <List.Item as='li'>Articles 107 and 108 of the Treaty on the Functioning of the European Union, Commission Regulation (EU) No 1407/2013 on the application of Articles 107 and 108 of the Treaty on the Functioning of the European Union to de minimis aid, Regulation (EU) 2021/1237 of 23 July 2021 amending Regulation (EU) No 651/2014 declaring certain categories of aid compatible with the internal market in application of Articles 107 and 108 of the Treaty; Delegated and Implementing acts, as well as all applicable decisions and rulings in the field of state aid;</List.Item>
                            <List.Item as='li'>All other EU legislation and the underlying principles applicable to the LP and the PPs, including the legislation laying down provisions on competition and entry into the markets, the protection of the environment, and the principles of sustainable development, equal opportunities, non-discrimination and equality between men and women;</List.Item>
                            <List.Item as='li'>National rules applicable to the LP and its PPs and their activities;</List.Item>
                            <List.Item as='li'>Project data, comprising all latest project documentation such as application form and all project information available in the electronic system (Jems);</List.Item>
                            <List.Item as='li'>All manuals, guidelines and any other documents relevant for project implementation (e.g., programme manual) in their latest version, as published on the programme website.</List.Item>
                        </List>
                        Should the above-mentioned documents, and any other documents or data of relevance for the contractual relationship be amended, the latest version shall apply.
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    };

    renderArticle2 = () => {
        return (
            <Grid>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <h3>Article 2 : Attribution du cofinancement et conditions générales</h3>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <h3>Article 2: Award of co-financing and general conditions</h3>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column width={8}>
                        1. Le contrat a pour objet l'attribution d'un cofinancement du programme par l'AG pour financer la mise en œuvre du projet {this.props.projectState.project.acronym}, conformément à la décision du Comité de Suivi du {this.getCommissionDate().fr}.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        1. The purpose of the contract is the award of programme co-financing by the MA to finance the implementation of the project {this.props.projectState.project.acronym}, in accordance with the decision of the Monitoring Committee of {this.getCommissionDate().en}.
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column width={8}>
                        2. Le CF accepte le cofinancement accordé et assume la responsabilité de coordonner la mise en œuvre du projet, en temps voulu, conformément aux dispositions du présent contrat.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        2. The LP accepts the awarded co-financing and assumes the responsibility to coordinate the implementation of the project, in due time, according to the provisions of the present contract.
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column width={8}>
                        3. Le cofinancement est accordé exclusivement pour le projet tel que décrit par la dernière version des données du projet (en particulier le formulaire de candidature approuvé) disponible dans le système électronique du programme (Jems), comme indiqué à l'article 1 du présent document.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        3. The co-financing is awarded exclusively for the project as described by the latest version of the project data (in particular the approved application form) available in the programme's electronic system (Jems) as referred to in Article 1 of this document.
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column width={8}>
                        4. Le cofinancement maximal du FEDER est stipulé dans la dernière version du formulaire de candidature disponible dans Jems.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        4. The maximum co-financing from the ERDF is stipulated in the latest version of the application form available in Jems.
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column width={8}>
                        5. Les PPs ayant le statut de micro-entreprise ou de micro-ONG peuvent demander une avance en suivant les conditions stipulées dans le manuel du programme. En cas d’acceptation, les paiements anticipés seront libérés au CF à la signature du contrat de subvention. Le CF distribuera ensuite les avances aux partenaires respectifs. Les paiements anticipés seront déduits de la demande de paiement à la fin du projet. Si un partenaire quitte le projet avant la fin de celui-ci, l'avance sera compensée à la fin de la participation de ce partenaire de projet.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        5. PPs with micro-enterprise or micro-NGO status can request an advance payment following the conditions stipulated in the programme manual. If accepted, the advance payments will be released to the LP upon signature of the subsidy contract. The LP will then distribute the advance payments to the respective partners. The advance payments will be offset against the payment claim at the end of the project. If a partner leaves the project before the project end date, the advance payment will be offset at the end of that partner’s participation in the project.
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column width={8}>
                        6. Le cofinancement réel du FEDER sera calculé sur la base des seules dépenses éligibles déclarées. Le montant total à payer par l'organisme comptable du programme (au nom de l'AG) au CF ne peut pas dépasser les montants maximaux des cofinancements approuvés.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        6. The actual ERDF co-financing will be calculated on the basis of reported eligible expenditure only. The total amount to be paid by the accounting body of the programme (on behalf of the MA) to the LP cannot exceed the maximum amounts of co-financing approved.
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column width={8}>
                        7. Le décaissement du cofinancement est soumis à la condition que la CE mette les fonds à disposition. En cas de non-disponibilité des fonds, l'AG a le droit de résilier ce contrat ou de réduire le montant du cofinancement accordé. Dans ces cas, toute action en justice de la part du CF ou des PPs contre l'AG est exclue. Dans ce cas, le CF sera dûment informé par l'AG et guidé sur les mesures respectives à prendre.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        7. Disbursement of the co-financing is subject to the condition that the EC makes the funds available. In the case of non-availability of funds, the MA is entitled to terminate this contract or reduce the awarded amount of co-financing. In these cases, any legal claim by the LP or PPs against the MA is excluded. In such a case, the LP will be duly notified by the MA and guided on the respective steps to be taken.
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column width={8}>
                        8. En cas de retard dans la disponibilité des fonds, l'AG peut retenir les paiements jusqu'à ce que les fonds soient disponibles et ne peut être tenue responsable des retards dans les paiements au projet. Dans ce cas, toute réclamation du CF ou des PPs à l'encontre de l'AG est exclue.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        8. In case of delays in the availability of funds, the MA can withhold payments until such a time as the funds are made available and cannot be held liable for delays in payments to the project. In this case, any claim by the LP or PPs against the MA is excluded.
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column width={8}>
                        9. S'il s'avère que le projet ne dépensera pas le montant maximal du cofinancement du programme accordé, le ou les organes compétents du programme peuvent décider de réduire ce montant en conséquence, en suivant la procédure spécifiée dans le manuel du programme.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        9. Should it become evident that the project will not spend the maximum amount of programme co-financing awarded, the relevant programme body/ies may decide to reduce this amount accordingly, following the procedure as specified in the programme manual.
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column width={8}>
                        10. Si un projet ne respecte pas les dispositions contractuelles relatives au respect des délais indiqués dans le plan de dépenses, à l'absorption du budget, aux règles de visibilité de l’UE et à la réalisation des produits et des résultats, comme indiqué dans les données du projet, des mesures correctives peuvent être mises en place pour garantir la performance du projet, ainsi que pour minimiser l'impact au niveau du programme (par exemple, l'adaptation du projet à la nouvelle situation), comme spécifié dans le manuel du programme. Le programme peut également réduire le cofinancement du programme alloué au projet ou, si nécessaire, arrêter le projet en résiliant le contrat de subvention comme stipulé dans l'article 12 de ce document.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        10. Should a project fail to respect the contractual arrangements on timeliness as indicated in the spending plan, budget absorption, EU visibility rules and achievement of outputs and results, as set out in the project data, corrective measures may be put in place to ensure the project performance, as well as minimize the impact at programme level (e.g., adaptation of the project to the changed situation), as specified in the programme manual. The programme may also reduce the programme co-financing allocated to the project or, if necessary, stop the project by terminating the subsidy contract as determined in Article 12 of this document.
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column width={8}>
                        11. Les paiements de cofinancement du programme qui ne sont pas demandés à temps et en totalité comme indiqué dans le plan de dépenses inclus dans le formulaire de demande peuvent être perdus.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        11. Programme co-financing payments not requested in time and in full as indicated in the spending plan included in the application form may be lost.
                    </Grid.Column>
                </Grid.Row>

            </Grid>
        )
    };

    renderArticle3 = () => {
        return (
            <Grid>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <h3>Article 3 : Éligibilité des dépenses</h3>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <h3>Article 3: Eligibility of expenditure</h3>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        1. Les dépenses qui peuvent bénéficier d'un cofinancement du programme sont exclusivement des dépenses éligibles. Les règles d'éligibilité des dépenses des projets pouvant bénéficier d'un cofinancement du programme sont définies dans le manuel du programme.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        1. Expenditure which qualifies for co-financing from the programme consists exclusively of eligible expenditure. Rules for eligibility of project expenditure qualifying for co-financing from the programme are laid down in the programme manual.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        2. Pour être cofinancées par le programme, les dépenses du projet doivent être conformes aux méthodes de détermination des coûts du projet (coûts réels ou options de coûts simplifiés) pour chaque catégorie de coûts, telles que définies dans le manuel du programme et les données du projet.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        2. To be co-financed by the programme, project expenditure has to comply with the methods for determining the costs of the project (real costs or simplified cost options) for each cost category as defined in the programme manual and project data.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        3. Le projet ne doit pas faire appel à des fonds provenant d'autres programmes cofinancés par l'UE pour financer les coûts éligibles rapportés au présent projet.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        3. The project must not make use of funds from other programmes co-financed by the EU to finance the eligible costs reported to the present project.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        4. La période d'éligibilité des coûts encourus par le projet est définie dans le manuel du programme et les données du projet, et doit être respectée par le projet.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        4. The eligibility period for costs incurred by the project is defined in the programme manual and the project data and must be respected by the project.
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    };

    renderArticle4and5 = () => {
        return (
            <Grid>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <h3>Article 4 : Obligations de rapport et paiement</h3>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <h3>Article 4: Reporting obligations and payment</h3>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        1. Le CF a le droit de demander des paiements à l'AG en suivant les procédures de rapport définies dans le manuel du programme. Après l'achèvement satisfaisant des rapports, le cofinancement sera versé par le ou les organismes du programme concernés sur le compte bancaire du CF indiqué dans les données du projet. Le cofinancement sera déboursé en euros (EUR, €). Tout risque de taux de change pour le transfert aux partenaires sera assumé par le CF, le cas échéant.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        1. The LP is entitled to request payments from the MA by following the reporting procedures defined in the programme manual. Upon satisfactory completion of reporting, co-financing will be disbursed by the relevant programme body/ies to the bank account of the LP indicated in the project data. Co-financing will be disbursed in Euro (EUR, €). Any exchange rate risk for transfer to the partners will be borne by the LP, if applicable.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        2. L'AG se réserve le droit de ne pas accepter, en partie ou en totalité, - les dépenses validées par les contrôleurs si, à la suite de ses propres vérifications et/ou contrôles ou d'audits réalisés par une autre autorité, la validation ou les faits qui y sont mentionnés s'avèrent incorrects, ou si les activités ou les dépenses sous-jacentes ne sont pas conformes au cadre légal tel que défini dans le présent contrat de subvention.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        2. The MA reserves the right not to accept – in part or in full – expenditure validated by controllers if – as a result of its own checks and/or controls or audits performed by another authority – the validation or the facts stated therein prove to be incorrect, or if the underlying activities or expenditure are not in line with the legal framework as set out in this subsidy contract.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        3. L'Autorité de Gestion veille à ce que le projet reçoive les paiements du cofinancement du programme en temps voulu et dans leur intégralité. Aucune déduction ou retenue d'autres frais spécifiques qui réduiraient le montant du paiement ne sera effectuée sans préjudice des dispositions énoncées ci-dessus dans le présent article. Réciproquement, la contribution FEDER versée par l'AG n'excèdera pas la part du FEDER résultant du montant éligible vérifié par chaque autorité de contrôle responsable, dans le respect des articles du présent contrat.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        3. The MA shall ensure that the project receives payments of the co-financing from the programme in time and in full. No deduction or retention of further specific charges which would reduce the amount of the payment shall be made without prejudice of the provisions outlined above in this article. Conversely, the ERDF contribution paid by the MA shall not exceed the share of ERDF resulting from the eligible amount verified by each responsible control authority, in compliance with the articles of this contract.
                    </Grid.Column>
                </Grid.Row>


                <Grid.Row>
                    <Grid.Column width={8}>
                        <h3>Article 5 : Modifications du projet</h3>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <h3>Article 5: Modifications to the project</h3>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        Les modifications du projet sont introduites par le CF selon les règles et procédures énoncées dans le manuel du programme. Le cas échéant, pour entrer en vigueur, ces modifications doivent être approuvées par le ou les organismes de programme concernés.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        Modifications in the project shall be introduced by the LP according to the rules and procedures stated in the programme manual. Where relevant, in order to come into effect, these modifications must be approved by the relevant programme body/ies.
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    };

    renderArticle6 = () => {
        return (
            <Grid>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <h3>Article 6 :  Tenue de documents, audit et évaluation</h3>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <h3>Article 6:  Document keeping, audit and evaluation</h3>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        1. Les organismes du programme, les organismes nationaux ainsi que tout organisme de l'UE compétent sont habilités à contrôler l'utilisation des fonds par le CF et les PPs, ou à faire en sorte qu'un tel contrôle soit effectué par des personnes autorisées.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        1. Programme bodies, national bodies as well as any relevant EU body are entitled to audit the use of funds by the LP and PPs or to arrange for such an audit to be carried out by authorised persons.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        2. Le CF et PPs doivent fournir tous les documents requis pour l'audit, ainsi que toutes les informations nécessaires, et donner accès à leurs locaux commerciaux, ainsi qu'aux lieux liés au projet.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        2. The LP and PPs must provide all documents required for the audit, as well as all necessary information, and give access to their business premises, as well as project-related locations.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        3. Le CF et PPs doivent également fournir à tout évaluateur autorisé toutes les informations et l'accès aux documents nécessaires à la réalisation des évaluations de programmes ou de projets.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        3. The LP and PPs must also provide all necessary information and access to documents for the purpose of carrying out programme or project evaluations to any authorised evaluator.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        4. Le CF et PPs sont tenus de s'assurer que tous les dossiers, documents et données relatifs au projet sont conservés à des fins d'audit. Les documents sont conservés pendant une période d'au moins 5 ans à compter du 31 décembre de l'année au cours de laquelle le dernier paiement de l'AG au projet est effectué. Des périodes de conservation plus longues peuvent s'appliquer en cas d'aide d'État ou conformément aux règles nationales.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        4. The LP and PPs are obliged to ensure that all files, documents and data related to the project are retained for audit purposes. The documents shall be kept for at least a 5-year retention period from 31 December of the year in which the last payment by the MA to the project is made. Longer retention periods may apply in case of state aid or in accordance with national rules.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        5. En cas de résiliation du présent contrat de subvention, les droits et obligations prévus par le présent article subsistent toutefois.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        5. Should this subsidy contract be terminated, the rights and duties stipulated in this article shall, however, persist.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        6. L'AG a le droit de retenir les paiements au CF jusqu'à ce que toutes les informations et tous les documents requis aient été fournis ou mis à disposition de la manière requise.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        6. The MA has the right to withhold the payments to the LP until all required information and documentation has been delivered or made available otherwise in the required way.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        7. L'AG a le droit d'effectuer des contrôles par échantillons en plus des contrôles effectués par les organismes nationaux de contrôle financier.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        7. The MA has the right to conduct sample checks in addition to the national financial control bodies' checks.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        8. L'AG, assistée par le secrétariat conjoint, peut à tout moment demander des informations et des pièces justificatives supplémentaires au CF et aux PPs, afin d'accomplir ses tâches de certification.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        8. The MA, assisted by the joint secretariat, can at any moment request additional information and supporting documents from the LP and PPs, in order to perform its certifying tasks.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        9. L'AG a le droit de suspendre les paiements si le projet fait l'objet de contrôles ou d'audits de la part de l'AG/SC, de l'AA ou des organes compétents de l'UE jusqu'à ce que ces contrôles ou audits soient terminés. Si l'AA émet des déclarations sur les systèmes de contrôle nationaux et identifie des problèmes de nature systémique, l'AG a le droit de suspendre les paiements au CF jusqu'à ce que le cas soit résolu.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        9. The MA has the right to suspend payments should the project become subject to controls or audits by the MA/JS, AA or relevant EU bodies until these controls or audits have been completed. Should the AA issue statements on the national control systems and identify problems of a systemic character, the MA has the right to suspend payments to the LP until the case has been resolved.
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    };

    renderArticle7 = () => {
        return (
            <Grid>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <h3>Article 7 : Rôles et responsabilités</h3>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <h3>Article 7: Roles and responsibilities, liability</h3>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        1. Le CF s'engage à respecter l'ensemble des règles et règlements visés à l'article 1 du présent contrat de subvention (y compris les modifications apportées à ces règles et règlements).
                    </Grid.Column>
                    <Grid.Column width={8}>
                        1. The LP undertakes to comply with the body of rules and regulations referred to in Article 1 of this subsidy contract (including any amendments made to these rules and regulations).
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        2. Le CF assume toutes les responsabilités définies dans le manuel du programme ; en particulier, les principales responsabilités du CF et les responsabilités après la clôture du projet.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        2. The LP shall assume all responsibilities laid down in the programme manual; in particular, the main responsibilities of the LP and the responsibilities after the project closure.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        3. Le CF doit s'assurer que la mise en œuvre du projet est conforme au plan de travail, au calendrier et au budget approuvé, comme indiqué dans les données du projet.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        3. The LP shall make sure that the project implementation is in line with the work plan, the time schedule and the approved budget, as indicated in the project data.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        4. Le CF fixe les modalités de ses relations avec les PPs et les responsabilités dans un accord de partenariat qui répond aux exigences minimales stipulées dans le manuel du programme.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        4. The LP shall lay down the arrangements for its relations with the PPs and liabilities in a partnership agreement that fulfils the minimum requirements stipulated in the programme manual.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        5. Le CF informe immédiatement l'AG de toutes les circonstances qui retardent, entravent ou rendent impossible la réalisation du projet, ainsi que de toutes les circonstances qui impliquent une modification des conditions de versement, ou qui donneraient à l'AG le droit de résilier le présent contrat de subvention, de cesser les versements ou d'exiger le remboursement du cofinancement, en totalité ou en partie.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        5. The LP informs the MA immediately about any circumstances that delay, hinder or make impossible the realisation of the project, as well as all circumstances that mean a change of the disbursement conditions, or which would entitle the MA to terminate this subsidy contract, to discontinue payments or to demand repayment of the co-financing, in full or in part.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        6. Le CF assume la responsabilité de fournir à l'AG toute information requise et demandée dans le cadre du projet, sans délai.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        6. The LP is responsible for providing the MA with any information required and requested in terms of the project, without delay.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        7. Le CF fournit à tous les autres partenaires une copie du contrat de subvention signé et veille à ce que les partenaires du projet respectent ses dispositions.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        7. The LP shall provide all other partners with a copy of the signed subsidy contract and shall ensure that the project partners comply with its provisions.
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    };

    renderArticle8 = () => {
        return (
            <Grid>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <h3>Article 8 : Recouvrements et fonds indûment versés</h3>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <h3>Article 8: Recoveries and unduly paid out funds</h3>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        1. Si un organisme du programme, un organisme national ou un organisme compétent de l'UE découvre des fonds indûment versés, ou si l'AG est informée de tels cas, elle demande le remboursement du cofinancement en tout ou en partie au CF.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        1. If any programme body, national body or any relevant EU body should discover any unduly paid out funds, or should the MA be notified of such cases, it shall demand repayment of the co-financing in whole or in part from the LP.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        2. Le CF veille à ce que, le cas échéant, le PP concerné rembourse au CF les sommes indûment versées, conformément à l'accord de partenariat et au manuel du programme. Le montant à rembourser peut être prélevé sur le prochain paiement au CF ou, le cas échéant, les paiements restants peuvent être suspendus. Dans le cas de projets clôturés ou sur demande de l'AG pour les projets en cours, le CF est tenu de transférer les fonds indûment versés à l'AG, après les avoir récupérés auprès du PP concerné, le cas échéant.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        2. The LP shall ensure that, if applicable, the PP involved repays the LP any amounts unduly paid, in accordance with the partnership agreement and the programme manual. The amount to be repaid can be withdrawn from the next payment to the LP or, where applicable, remaining payments can be suspended. In the case of closed projects or upon request by the MA for ongoing projects, the LP is obliged to transfer the unduly paid out funds to the MA, after having recovered it from the PP concerned, if applicable.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        3. Si le CF ou un PP impliqué dans ce projet ne rembourse pas les fonds indûment versés dans un autre projet financé par le programme, l'AG a le droit de retirer les fonds correspondants relatifs au CF ou PP en question sur tout paiement ouvert dans ce projet.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        3. If the LP or a PP involved in this project fails to repay unduly paid funds in another project funded by the programme, the MA has the right to withdraw the corresponding funds relating to the LP or PP in question from any open payment in this project.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        4. Dans le cas où le chef de file ne parvient pas à obtenir le remboursement du partenaire malgré ses efforts, ou lorsque l'AG ne parvient pas à obtenir le remboursement du Chef de File, alors en vertu du Règlement (UE) N° 2021/1059, l'État membre ou le pays tiers sur le territoire duquel le PP concerné est situé (ou, dans le cas d'un GECT, est enregistré), rembourse à l'AG les montants indûment versés à ce PP. Cet État membre ou pays tiers est alors en droit de réclamer ce montant au PP concerné sur la base de son droit national.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        4. If despite their efforts, the LP does not succeed in securing repayment from the partner, or if the MA does not succeed in securing repayment from the LP, then, in accordance with article 52 of Regulation (EU) No 2021/1059, the Member State or third country on whose territory the PP concerned is located (or in case of an EGTC, is registered), shall reimburse the MA any amounts unduly paid to that PP. This Member State or third country is then entitled to claim this amount from the PP concerned based on its national law.
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    };

    renderArticle9 = () => {
        return (
            <Grid>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <h3>Article 9 : Information et communication, publicité et droits de propriété intellectuelle</h3>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <h3>Article 9: Information and communication, publicity and intellectual property rights</h3>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        1. Le CF doit s'assurer que les PPs respectent toutes les obligations en matière de publicité, de communication et d'image de marque conformément aux règlements énumérés à l'article 1 du présent document et tels que précisés dans le manuel du programme.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        1. The LP shall ensure that the PPs comply with all publicity, communication and branding obligations according to the regulations listed in Article 1 of this document and as further specified in the programme manual.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        2. Le CF assume l'entière responsabilité du contenu de tout avis, publication ou document rédigé par le CF, l'un des PPs ou des tiers au nom du CF ou des PPs. Si un tiers réclame des dommages-intérêts (par exemple, en raison d'une violation des droits de propriété intellectuelle), le CF indemnisera l'AG si celle-ci subit un quelconque préjudice du fait de cette réclamation.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        2. The LP takes full responsibility for the content of any notice, publication or material developed by the LP, any of the PPs, or third parties on behalf of the LP or the PPs. Should a third-party claim compensation for damages (e.g., due to an infringement of intellectual property rights), the LP will indemnify the MA should the MA suffer any damage because of this claim.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        3. L’AG a le droit d'utiliser les résultats du projet afin de garantir une large diffusion des résultats et des produits du projet, et de les mettre à la disposition du public. Le CF accepte que les résultats soient transmis par l'AG aux autres autorités du programme, ainsi qu'aux pays participant au programme, afin d'utiliser ce matériel pour montrer comment le cofinancement est utilisé.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        3. The MA is entitled to use the outputs of the project in order to guarantee a wide dissemination of the project deliverables and outputs, and to make them available to the public. The LP agrees that the outputs are forwarded by the MA to other programme authorities, as well as the countries participating in the programme, to use this material to showcase how the co-financing is used.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        4. Toute campagne de communication, apparition dans les médias ou autre publicité du projet doit être communiquée à l'AG/SC pour d'éventuelles mises à jour du site Internet ou mise en avant d’exemples choisis.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        4. Any communication campaign, media appearance or other publicity of the project shall be communicated to the MA/JS for potential website updates or showcases.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        5. Dans un esprit de coopération et d'échange, le CF et les PPs veillent à ce que toutes les réalisations et tous les résultats produits pendant le projet soient d'intérêt public et accessibles au public. L’AG/SC et tout autre programme, organisme européen et national concerné peuvent les utiliser à des fins d'information et de communication dans le cadre du programme.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        5. In the spirit of cooperation and exchange, the LP and the PPs shall ensure that all the outputs and results produced during the project are in the public interest and publicly available. The MA/JS and any other relevant programme, EU and national body can use them for information and communication purposes in the framework of the programme.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        6. Le CF s'assure qu'il dispose de tous les droits d'utilisation des droits de propriété intellectuelle préexistants, si cela s'avère nécessaire pour la mise en œuvre du projet.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        6. The LP shall ensure that it has all rights to use any pre-existing intellectual property rights, if necessary for the implementation of the project.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        7. Le CF doit informer l'AG s'il existe des informations sensibles ou confidentielles, ou des droits de propriété intellectuelle préexistants liés au projet qui doivent être respectés.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        7. The LP shall inform the MA if there is any sensitive or confidential information, or any pre-existing intellectual property rights related to the project that must be respected.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        8. Le CF s'assure que tous les PPs respectent les mentions légales et la politique de confidentialité du site Internet du programme pour l'hébergement, la maintenance et l'édition du site Internet du projet, comme décrit dans le manuel du programme. L'AG s'engage à protéger les données personnelles, conformément au Règlement général sur la protection des données (RGPD). Le CF s'assure que tous les PPs reconnaissent et traitent les données en conformité avec le règlement susmentionné lors de la mise en œuvre des activités du projet.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        8. The LP ensures that all PPs respect the legal notice and privacy policy of the programme website for hosting, maintaining, and editing the project’s website, as described in the programme manual. The MA is committed to the protection of personal data, in accordance with the General Data Protection Rules (GDPR). The LP ensures that all PPs acknowledge and process data in conformity with the above-mentioned Regulation when implementing project activities.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        9. Le CF autorise l'AG à utiliser le matériel de communication et de visibilité produit par le projet pour illustrer l'utilisation du cofinancement. Le CF autorise en outre le ou les organes de programme concernés à transmettre ce matériel à d'autres organes de programme, aux promoteurs de programme au niveau national, ainsi qu'aux institutions, organes, bureaux ou agences de l'Union. À cette fin, le CF veille à ce qu'une licence gratuite, non exclusive et irrévocable d'utilisation de ce matériel et de tous les droits préexistants qui y sont attachés soit accordée aux organismes du programme et de l'Union, conformément à l'annexe IX de la décision (UE) 2021/1060 et comme précisé dans le manuel du programme.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        9. The LP authorises the MA to use communication and visibility material produced by the project to showcase how the co-financing is used. The LP furthermore authorises the relevant programme body/ies to forward this material to other programme bodies, programme promoters at national level, as well as Union institutions, bodies, offices or agencies. For this purpose, the LP ensures that a royalty-free, non-exclusive and irrevocable licence to use such material and any pre-existing rights attached to it is granted to the Programme and Union bodies in accordance with Annex IX of (EU) 2021/ 1060 and further specified in the programme manual.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        10. L'AG est autorisée à publier, sous quelque forme que ce soit et sur ou par quelque support que ce soit, y compris l'Internet, des (parties des) données du projet afin de remplir ses propres obligations de rapport, de communication et de visibilité découlant de l'ensemble des règles et règlements énumérés à l'article 1. Les données personnelles sont traitées conformément au RGPD (cf. article 13 du présent document).
                    </Grid.Column>
                    <Grid.Column width={8}>
                        10. The MA shall be authorised to publish, in whatever form and on or by whatever medium, including the Internet, (parts of) the project data in order to fulfil its own reporting, communication and visibility obligations arising from the body of rules and regulations listed in Article 1. Personal data shall be processed in line with the GDPR (cf. Article 13 of this document).
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    };

    renderArticle10 = () => {
        return (
            <Grid>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <h3>Article 10 : Cession, succession légale</h3>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <h3>Article 10: Assignment, legal succession</h3>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        1. L'AG peut à tout moment céder à des tiers ses droits découlant du contrat de subvention. Si l'AG décide de le faire, elle en informera immédiatement le CF.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        1. The MA is entitled at any time to assign its rights under the subsidy contract to third parties. Should the MA decide to do so, it will immediately inform the LP.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        2. Le CF n'est autorisé à céder ses obligations et ses droits à des tiers dans le cadre du contrat de subvention qu'après accord écrit préalable de l'AG.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        2. The LP is allowed to assign its duties and rights to third parties under the subsidy contract only after prior written consent from the MA.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        3. En cas de succession juridique, le CF transfère tous les droits et obligations découlant du présent contrat de subvention à son successeur juridique et informe l'AG de cette succession juridique. Il en est de même en cas de succession juridique pour un ou plusieurs des PPs.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        3. In the event of legal succession, the LP shall transfer all rights and duties under this subsidy contract to its legal successor and shall inform the MA of this legal succession. The same shall apply in case of legal succession for one or more of the PPs.
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    };

    renderArticle11 = () => {
        return (
            <Grid>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <h3>Article 11 : Réclamations et litiges</h3>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <h3>Article 11: Complaints and litigation</h3>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        1. Le CF a le droit de déposer une plainte officielle au nom du partenariat contre tout acte et/ou décision de l’AG/SC lié à l'exécution du contrat de subvention.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        1. The LP is entitled to file a formal complaint on behalf of the partnership against any act and/or decision by the JS/MA related to the execution of the subsidy contract.
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column width={8}>
                        2. Le présent contrat est régi par et interprété conformément au droit français, l’AG ayant son siège en France.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        2. This contract is governed by and construed in accordance with the laws of France, where the MA is located.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        3. En cas de litige entre l'AG et le CF, les solutions amiables seront privilégiées avant toute procédure judiciaire. La procédure à suivre est décrite dans le manuel du programme.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        3. Should a dispute arise between the MA and the LP, amicable solutions shall be used prior to legal proceedings. The procedure to follow is laid down in the programme manual.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        4. En cas de litige, le tribunal administratif de Lille est compétent.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        4. In case of litigation, the administrative tribunal of Lille shall be competent.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        5. Selon la loi française n° 94-665 du 4 août 1994, une version française du contrat doit être établie. Les versions anglaise et française du présent contrat sont en vigueur. Les parties contractantes pourront invoquer les dispositions des deux versions.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        5. According to French law number 94-665 of the 4 August 1994, a French version of the contract has to be set. The English and French versions of the present contract are in force. The contracting parties will be able to invoke the provisions of the two versions.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        6. En cas de contradiction entre la version française et la version anglaise, la commune intention des parties prévaut.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        6. In case of contradiction between the French and the English version, the common intention of the parties shall take precedence.
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    };

    renderArticle12 = () => {
        return (
            <Grid>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <h3>Article 12 : Résiliation du contrat</h3>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <h3>Article 12 : Termination of the contract</h3>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        1. L’AG peut résilier le contrat de cofinancement et exiger le remboursement du cofinancement du programme, en totalité ou en partie, si :
                        <List>
                            <List.Item>
                                <List.List>
                                    <li>a) les informations que les PPs devaient fournir lors de la procédure d’évaluation et de sélection, de la phase des conditions ou de la mise en œuvre du projet, étaient fausses ou incomplètes ;</li>
                                    <li>b) le CF ne remplit pas une condition ou une obligation résultant du contrat de subvention ;</li>
                                    <li>c) un partenaire devient insolvable, fait l’objet d’une administration judiciaire, a conclu un concordat préventif, a suspendu ses activités commerciales, fait l’objet d’une procédure de faillite ou d’une procédure relative à ces questions, ou se trouve dans toute autre situation analogue ;</li>
                                    <li>d) les partenaires, ou toute personne liée, ont commis une fraude ou sont impliqués dans toute activité illégale portant atteinte aux intérêts financiers de l’UE ;</li>
                                    <li>e) le retrait d’un partenaire du projet ou le changement de statut d’un partenaire du projet affecte substantiellement la réalisation du projet ou remet en cause la décision d’attribution ;</li>
                                    <li>f) le projet n’a pas été ou ne peut pas être entièrement mis en œuvre, ou il n’a pas été ou ne peut pas être mis en œuvre en temps voulu ;</li>
                                    <li>g) le projet n’a pas atteint de manière significative les objectifs, les résultats et les réalisations prévus dans le formulaire de candidature, sauf si cela est dûment justifié ;</li>
                                    <li>h) le CF n’a pas soumis les rapports requis, les preuves ou les informations nécessaires demandées par les organismes du programme dans le délai fixé, à condition que le CF ait reçu au moins un rappel écrit fixant le délai et précisant les conséquences juridiques d’un manquement aux exigences ;</li>
                                    <li>i) le cofinancement du programme a été partiellement ou entièrement appliqué à des fins autres que celles convenues ;</li>
                                    <li>j) le CF a entravé ou empêché l’audit du projet, ou n’a pas conservé la documentation du projet requise pour l’audit ;</li>
                                    <li>k) le CF n’a pas signalé immédiatement les événements qui retardent ou empêchent la mise en œuvre du projet, ou toute circonstance conduisant à sa modification ;</li>
                                    <li>l) La législation européenne et/ou la législation nationale ont été violées par le CF ou un PP.</li>
                                </List.List>
                            </List.Item>

                        </List>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        1. The MA may terminate the co-financing contract and demand the repayment of programme co-financing, in full or in part, if:
                        <List>
                            <List.Item>
                                <List.List>
                                    <li>a) the information the PPs were required to provide in the assessment and selection procedure, conditions phase or the implementation of the project was false or incomplete;</li>
                                    <li>b) the LP fails to fulfil any condition or obligation resulting from the subsidy contract;</li>
                                    <li>c) a partner becomes insolvent, is having its affairs administered by the courts, has entered into an arrangement with creditors, has suspended business activities, is the subject of bankruptcy proceedings, or proceedings concerning those matters, or is in any other analogous situation;</li>
                                    <li>d) the partners, or any related person, have committed fraud or are involved in any illegal activity detrimental to the EU’s financial interests;</li>
                                    <li>e) the withdrawal of a project partner or a change in a project partner’s status substantially affects the implementation of the project or puts into question the award decision;</li>
                                    <li>f) the project has not been or cannot be fully implemented, or it has not been or cannot be implemented in due time;</li>
                                    <li>g) the project significantly failed to reach the objectives, results and outputs planned in the application form, unless duly justified;</li>
                                    <li>h) the LP has failed to submit required reports, proof or necessary information requested by the programme bodies within the set deadline, provided that the LP has received at least one written reminder setting the deadline and specifying the legal consequences of a failure to comply with the requirements;</li>
                                    <li>i) the programme co-financing has been partially or entirely applied for purposes other than those agreed upon;</li>
                                    <li>j) the LP has impeded or prevented the auditing of the project, or failed to retain the project documentation required for the audit;</li>
                                    <li>k) the LP has failed to immediately report events delaying or preventing the implementation of the project, or any circumstances leading to its modification;</li>
                                    <li>l) EU legislation and/or national legislation has been violated by the LP or a PP.</li>
                                </List.List>
                            </List.Item>
                        </List>

                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        2. En cas de résiliation du présent contrat par l’AG, le CF recevra un avis écrit contenant les instructions nécessaires concernant la clôture du projet. Lorsque la résiliation du contrat est fondée sur le paragraphe 1 du présent article, l’AG peut demander le remboursement total ou partiel des montants déjà versés au titre du cofinancement du programme, proportionnellement à la gravité de l’irrégularité en question, après avoir permis au CF de présenter ses explications. L’AG informe le CF en lui donnant un préavis écrit d’au moins 30 jours et sans verser de compensation d’aucune sorte. À la fin de la période de préavis, l’AG confirmera la résiliation du contrat (sauf si de nouvelles informations fournies pendant la période de préavis permettent à l’AG de reconsidérer la résiliation du contrat).
                    </Grid.Column>
                    <Grid.Column width={8}>
                        2. Upon termination of this contract by the MA, the LP shall receive a written notice with necessary instruction regarding the closure of the project. Where termination of the contract is based on paragraph 1 of this article, the MA may request full or partial repayment of amounts already paid from the programme co-financing, in proportion to the gravity of the irregularity in question, after allowing the LP to submit its clarification. The MA shall inform the LP by giving a minimum 30 day written notice and without paying compensation of any kind. At the end of the notice period, the MA will confirm the termination of the contract (unless new information provided during the notice period allows the MA to reconsider the termination of the contract).
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        3. En cas de force majeure, c’est-à-dire si des circonstances exceptionnelles rendent la mise en œuvre du projet excessivement difficile ou dangereuse, et si le contrat de subvention ne peut plus être exécuté de manière efficace et appropriée, les parties peuvent résilier le contrat de subvention moyennant un préavis écrit d’au moins 30 jours, sans être tenues de payer une indemnité. L’AG peut rembourser les dépenses résiduelles inévitables engagées pendant la période de préavis (mais uniquement pour les activités et les dépenses qui ont été correctement exécutées).
                    </Grid.Column>
                    <Grid.Column width={8}>
                        3. In the case of force majeure; i.e., if exceptional circumstances make implementation of the project excessively difficult or dangerous, and if the subsidy contract can no longer be executed effectively and appropriately, the parties may terminate the subsidy contract by serving a minimum 30 -day written notice, without being required to pay indemnity. The MA may reimburse the unavoidable residual expenditures incurred during the notice period (but only for activities and expenditures that have been properly executed).
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        4. Le CF est en droit de demander des paiements au programme uniquement pour la partie du projet réalisée et les activités exécutées avant la résiliation du contrat et soumises au programme avant la date limite indiquée dans la lettre de résiliation.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        4. The LP shall be entitled to request payments from the programme only for the part of the project carried out and activities executed before the termination of the contract and submitted to the programme by the deadline indicated in the termination letter.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        5. Le contrat peut être résilié par accord mutuel écrit entre le CF et l’AG.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        5. The contract may be terminated by written mutual agreement between the LP and MA.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        6. Lors de la résiliation du contrat, les obligations du CF qui sont encore pertinentes (notamment celles mentionnées aux articles 6, 7, 8, 9 et 10) continuent de s’appliquer jusqu’à la fin du délai mentionné à l’article 6.4.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        6. Upon termination of the contract, the obligations of the LP which are still relevant (in particular those mentioned in articles 6, 7, 8, 9 and 10) continue to apply until the end of the period mentioned in article 6.4.
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    };

    renderArticle13 = () => {
        return (
            <Grid>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <h3>Article 13 : Gestion et protection des données</h3>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <h3>Article 13: Data management and data protection</h3>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        1. Toute donnée à caractère personnel dans le cadre du contrat de subvention est traitée par l'AG/SC ou d'autres organismes de programme pertinents conformément au règlement (UE) 2016/679 du Parlement européen et du Conseil du 27 avril 2016 relatif à la protection des personnes physiques à l'égard du traitement des données à caractère personnel et à la libre circulation de ces données (règlement général sur la protection des données/ RGPD) et aux conditions générales du système Jems.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        1. Any personal data under the subsidy contract shall be processed by the MA/ JS or other relevant programme bodies in accordance with Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural person with regard to the processing of personal data and on the free movement of such data (General Data Protection Regulation/ GDPR) and the terms and conditions of Jems.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        2. Conformément à l'article 4 du Règlement (UE) 1060/2021, l'AG, les autres organismes du programme et la Commission sont autorisés à traiter les données à caractère personnel lorsque cela est nécessaire pour remplir leurs obligations respectives au titre de l'ensemble des règles et règlements visés à l'article 1, notamment pour le suivi, l'établissement de rapports, la communication, la publication, l'évaluation, la gestion financière, les vérifications et les audits et, le cas échéant, pour déterminer l'éligibilité des participants.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        2. In accordance with Article 4 of (EU) 1060/2021, the MA, other programme bodies and the Commission shall be allowed to process personal data where necessary for the purpose of carrying out their respective obligations under the body of rules and regulations referred to in Article 1, in particular for monitoring, reporting, communication, publication, evaluation, financial management, verifications and audits and, where applicable, for determining the eligibility of participants.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        3. L'AG peut transférer les données relatives au projet et/ou les données personnelles aux organes du programme et aux autorités nationales concernées aux mêmes fins que celles énumérées au paragraphe 2 du présent article.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        3. The MA may transfer project and /or personal data to relevant programme bodies and national authorities for the same purposes as listed in paragraph 2 of this article.
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    };

    renderFinalProvisions = () => {
        return (
            <Grid>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <h3>Dispositions finales</h3>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <h3>Final Provisions</h3>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        1. Le manuel du programme et les données du projet sont considérés comme faisant partie intégrante du contrat de subvention. En cas de modification du manuel du programme, la dernière version s'applique dès sa publication sur le site du programme et le CF sera informé de cette publication. Toute modification substantielle des données du projet fera l'objet d'une demande de changement soumise par le CF dans Jems et approuvée par le SC au nom de l'AG.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        1. The programme manual and the project data are considered as an integral part of the subsidy contract. In case the programme manual is modified, the latest version applies as soon as it is published on the programme website and the LP will be informed about this publication. Any substantial modification of the project data will be subject to a request for change submitted by the LP in Jems and approved by the JS on behalf of the MA.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        2. Le présent contrat de subvention entre en vigueur à la date de la signature de la dernière de ses deux parties, AG ou CF. Dans le cas des activités du projet réalisées dans la phase postérieure au jour de la décision de sélection par le Comité de suivi mais avant l'entrée en vigueur du présent contrat de subvention tel que défini ci-dessus, les dispositions du présent contrat de subvention s'appliquent déjà à cette phase de réalisation du projet.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        2. This subsidy contract shall enter into force on the date the last of its two parties, MA or LP signs. In the case of project activities carried out in the phase after the day of the selection decision by the Monitoring Committee but before the entry into force of this subsidy contract as defined above, the provisions of this subsidy contract shall already apply to this phase of project implementation.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        3. La période d'exécution du présent contrat prend fin lorsque les obligations prévues par le présent contrat sont remplies tant par l'AG que par le CF, et que le délai mentionné à l'article 6.4 est expiré.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        3. The execution period of this contract shall end when the obligations set forth in this contract are fulfilled both by the MA and the LP and the period mentioned in article 6.4 has expired.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        4. Si une disposition du présent contrat de subvention s'avérait totalement ou partiellement inapplicable, les parties au contrat de subvention s'engagent à remplacer la disposition inapplicable par une disposition applicable qui se rapproche le plus possible de l'objectif de la disposition inapplicable.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        4. If any provision in this subsidy contract should be wholly or partly ineffective, the parties to the subsidy contract undertake to replace the ineffective provision by an effective provision which comes as close as possible to the purpose of the ineffective provision.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        5. Les modifications du présent contrat doivent être faites par écrit.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        5. Amendments to the present contract must be made in writing.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8}>
                        6. La langue du Programme est l'anglais. Par conséquent, toute correspondance avec le SC et l’AG dans le cadre de ce contrat doit être en anglais et doit être envoyée au SC.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        6. The Programme language is English. Therefore, all correspondence with the JS and MA authority under this contract must be in English and must be sent to the JS.
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column width={8}>
                        Annexe 1 - Dernière version approuvée du formulaire de candidature disponible dans Jems
                    </Grid.Column>
                    <Grid.Column width={8}>
                        Annex 1 - Latest approved version of the application form available in Jems
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    };

    renderSignatures = () => {
        return (
            <Grid className='page-break-before prevent-page-break signature-smaller-text'>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <span className="signature-title">Signatures</span>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <span className="signature-title">Signatures</span>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column width={8}>
                        <span className="signature-subtitle">Pour l'Autorité de Gestion :</span>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <span className="signature-subtitle">For the Managing Authority:</span>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column width={8}>
                        J'accepte par la présente le contenu et les dispositions du contrat de subvention.<br />
                        Je confirme également être officiellement habilité à signer ce contrat.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        I hereby accept the content and provisions of the subsidy contract.<br />
                        I also confirm to be officially entitled to sign this contract.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row className="grid-row-fixed-size">
                    <Grid.Column width={8}>
                        <span className="italic-text">Prénom et nom du signataire</span><br />
                        Name and surname of the signatory:
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <br />
                        ……………………………………………………
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row className="grid-row-fixed-size">
                    <Grid.Column width={8}>
                        <span className="italic-text">Fonction du signataire</span><br />
                        Function of the signatory:
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <br />
                        ……………………………………………………
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row className="grid-row-fixed-size">
                    <Grid.Column width={8}>
                        <span className="italic-text">Nom de l’organisation</span> <br />
                        Name of the organisation:
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <br />
                        ……………………………………………………
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row className="grid-row-fixed-size">
                    <Grid.Column width={8}>
                        <br />
                        Signature
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <br />
                        ……………………………………………………
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row className="grid-row-fixed-size">
                    <Grid.Column width={8}>
                        <br />
                        Date
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <br />
                        ……………………………………………………
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column width={8}>
                        <span className="signature-subtitle">Pour le Chef de File :</span>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <span className="signature-subtitle">For the Lead Partner:</span>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column width={8}>
                        J'accepte par la présente le contenu et les dispositions du contrat de subvention.<br />
                        Je confirme également être officiellement habilité à signer ce contrat.
                    </Grid.Column>
                    <Grid.Column width={8}>
                        I hereby accept the content and provisions of the subsidy contract.<br />
                        I also confirm to be officially entitled to sign this contract.
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row className="grid-row-fixed-size">
                    <Grid.Column width={8}>
                        <span className="italic-text">Prénom et nom du signataire</span><br />
                        Name and surname of the signatory:
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <br />
                        ……………………………………………………
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row className="grid-row-fixed-size">
                    <Grid.Column width={8}>
                        <span className="italic-text">Fonction du signataire</span><br />
                        Function of the signatory:
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <br />
                        ……………………………………………………
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row className="grid-row-fixed-size">
                    <Grid.Column width={8}>
                        <span className="italic-text">Nom de l’organisation</span> <br />
                        Name of the organisation:
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <br />
                        ……………………………………………………
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row className="grid-row-fixed-size">
                    <Grid.Column width={8}>
                        <br />
                        Signature
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <br />
                        ……………………………………………………
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row className="grid-row-fixed-size">
                    <Grid.Column width={8}>
                        <br />
                        Date
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <br />
                        ……………………………………………………
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    };

    render() {
        return (
            <div className="margin-notification-letter subsidy-contract-text">
                <table>
                    <thead>
                        <tr>
                            <div className="print-margin-top-15mm"></div>
                        </tr>
                    </thead>
                    <tbody >
                        <Grid>
                            <Grid.Row>
                                <Grid.Column width={8}>
                                    <Image className="center-image" src={logo} size='medium' />
                                </Grid.Column>
                                <Grid.Column textAlign="center" width={8}>
                                    <Image className="center-image" src={logoHdf} size='tiny' />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        <tr>
                            <td>
                                {this.renderSubsidyHeader()}
                                {this.renderArticle1()}
                                {this.renderArticle2()}
                                {this.renderArticle3()}
                                {this.renderArticle4and5()}
                                {this.renderArticle6()}
                                {this.renderArticle7()}
                                {this.renderArticle8()}
                                {this.renderArticle9()}
                                {this.renderArticle10()}
                                {this.renderArticle11()}
                                {this.renderArticle12()}
                                {this.renderArticle13()}
                                {this.renderFinalProvisions()}
                                {this.renderSignatures()}
                            </td>
                        </tr>
                    </tbody>
                    <tfoot >
                        <tr>
                            <td>
                                <div className="print-margin-bottom-10mm"></div>
                            </td>
                        </tr>
                    </tfoot>
                </table>

            </div>


            // <div className='margin-report-1'>
            //     <table>
            //         <thead>
            //             <tr>
            //                 <td><Image src={logo} size='medium' /></td>
            //                 <td><Image src={logoHdf} size='tiny' /></td>
            //             </tr>
            //         </thead>
            //         <tbody >
            //             <tr className='page-break full-width'>
            //                 <td>
            //                     <h2 className='title'>Step 1 Assessment Report </h2>

            //                     <h3 >Summary of project</h3>


            //                 </td>
            //             </tr>
            //             <tr className='page-break full-width'>
            //                 <td>
            //                     <h3>STEP 1 Eligibility CheckList</h3>

            //                 </td>
            //             </tr>
            //             <tr className='page-break full-width'>
            //                 <td>
            //                     <h3>STEP 1 Quality Assessment</h3>

            //                 </td>
            //             </tr>
            //             <tr className='page-break full-width'>
            //                 <td>
            //                     <h3>JS Opinion</h3>

            //                 </td>
            //             </tr>
            //         </tbody>
            //     </table>
            // </div>

            // <div>
            //     Subsidy Contract
            // </div>
        )
    }
}

export default SubsidyContract;
